/**
 * Environment configuration, read once.
 *
 * Nothing here is a secret. A SPA is a public client: the client ID and tenant
 * ID are published in the bundle by design, the flow is PKCE, and there is no
 * client secret to leak because there is none. If you ever find yourself
 * wanting to put one here, the call belongs on the API instead.
 */

const env = import.meta.env

/**
 * Empty in production: the Static Web App serves `/api` from the linked
 * Function App on the same origin. Set only to point a local build elsewhere.
 */
export const API_BASE_URL: string = env.VITE_API_BASE_URL ?? ''

export const ENTRA = {
  clientId: env.VITE_ENTRA_CLIENT_ID ?? '',
  tenantId: env.VITE_ENTRA_TENANT_ID ?? '',
  /** Scope exposed by the *API* app registration, not the SPA one. */
  apiScope: env.VITE_API_SCOPE ?? '',
}

const missing = Object.entries(ENTRA)
  .filter(([, value]) => !value)
  .map(([key]) => key)
if (missing.length > 0) {
  // Fail loudly at boot rather than at the first sign-in redirect, where the
  // error surfaces as an opaque Entra page.
  throw new Error(
    `Missing configuration: ${missing.join(', ')}. Set them in .env.local ` +
      '(see .env.example), or as pipeline variables for a deployed build.',
  )
}
